import { render, staticRenderFns } from "./DigitalShare.vue?vue&type=template&id=c1feeb36&scoped=true&"
import script from "./DigitalShare.vue?vue&type=script&lang=js&"
export * from "./DigitalShare.vue?vue&type=script&lang=js&"
import style0 from "./DigitalShare.vue?vue&type=style&index=0&id=c1feeb36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1feeb36",
  null
  
)

export default component.exports